import {
  ContainerOutlined,
  EyeOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  DeleteRowOutlined,
} from '@ant-design/icons';
import {
  useLazyQuery,
  useMutation,
  useQuery,
  useSubscription,
} from '@apollo/client';
import { Button, Form, message, Space, Tag, Tooltip, Modal } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import React, { useEffect, useState } from 'react';
import { PageContext } from '../../../lib/context';
import mutations from '../../../utils/gql/mutations';
import queries from '../../../utils/gql/queries';
import CustomersView from './customers';
import { subscriptions } from '../../../utils/gql/subscriptions';
import moment from 'moment';
import philippines from '../../../assets/philippines.json';
import { Link, useParams } from 'react-router-dom';
import confirm from 'antd/lib/modal/confirm';
import { transpileModule } from 'typescript';
import auth from '../../../lib/services';
import { client } from '../../../lib/client';

interface Customer {
  id: number;
  first_name: string;
  last_name: string;
  name: string;
  barangay: string;
  created_at: Date;
  comsumer_type: number;
  complete_address: string;
  meter_id: number;
  middle_name: string;
  mobile_number: string;
  municipality: string;
  zip_code: string;
}

interface Meter {
  id: number;
  serial_number: string;
}

interface Rate {
  id: number;
  name: string;
}
interface AdditionalFees {
  id: number;
  title: string;
}

interface CustomAddFees {
  title: string;
  amount: number;
}

interface Sort {
  id: string | null | boolean;
  meter: Serial;
  first_name: string | null | boolean;
  municipality: string | null | boolean;
  is_active: string | null | boolean;
  total_bill?: {
    aggregate?: {
      sum?: {
        total_balance?: string | null | boolean;
      };
    };
  };
}

interface Serial {
  serial_number?: string | null | boolean;
}

const CustomerController = (record: any) => {
  const params: any = useParams();
  const [getCustomer, { data, error, loading }] = useLazyQuery(
    queries.GET_CUSTOMER_RECORD
  );
  const [total, setTotal] = useState<number>();
  const [limit, setLimit] = useState<number>(10);
  const [offset, setOffset] = useState<number>(0);
  const [current, setCurrent] = useState<number>(1);
  const [sort, setSort] = useState<any>(null);
  const [sortOrder, setSortOrder] = useState<Sort>({
    id: false,
    meter: {
      serial_number: false,
    },
    first_name: false,
    municipality: false,
    is_active: false,
    total_bill: {
      aggregate: {
        sum: {
          total_balance: false,
        },
      },
    },
  });
  const [subscribers, setSubscribers] = useState<Customer[]>([]);
  const [meters, setMeters] = useState<Meter[]>([]);
  const [rates, setRates] = useState<Rate[]>([]);
  const [addFees, setAddFees] = useState<AdditionalFees[]>([]);
  const [active, setActive] = useState<boolean>(true);
  const [show, setShow] = useState<boolean>(false);
  const [edit] = useState<boolean>(true);
  const [info, setInfo] = useState(null);
  const [billingInfo] = useState(null);
  const [meterInfo] = useState<any>();
  const [settingsInfo, setSettingsInfo] = useState<any>();
  const [rateInfo] = useState<any>();
  const [paymentsInfo, setPaymentsInfo] = useState<any>();
  const [visible, setVisible] = useState(false);
  const [displayAmount] = useState<boolean>(true);
  const [name] = useState<any>();
  const [meter_id, setMeterId] = useState<string>('');
  const [showForm, setShowForm] = useState<boolean>(false);
  const [selectedSubAddFees] = useState<any>();
  const [showFees, setShowFees] = useState<boolean>(false);
  const [addFeesTable, setAddFeesTable] = useState<Array<any>>([]);
  const [notesTable, setNotesTable] = useState<Array<any>>([]);
  const [billsTable, setBillsTable] = useState<Array<any>>([]);
  const [meterReadingTable, setMeterReadingTable] = useState<Array<any>>([]);
  const [paymentsTable, setPaymentsTable] = useState<Array<any>>([]);
  const [user, setUser] = useState<any>(null);
  const [userBill, setUserBill] = useState<any>(null);
  const [userPayments, setUserPayments] = useState<any>(null);
  const [userMeterReading, setUserMeterReading] = useState<any>(null);
  const [showMeter, setShowMeter] = useState<boolean>(true);
  const [showReceit, setShowReceit] = useState<boolean>(false);
  const [graphDatas, setGraphDatas] = useState({ labels: [], data: [] });
  const [municipalities, setMunicipalities] = useState<
    { label: string; value: string; barangays: object }[]
  >([]);
  const [barangays, setBarangays] = useState([]);
  const [filterBarangays, setFilterBarangays] = useState([]);
  const [customAddFees, setCustomAddFees] = useState<CustomAddFees[]>([
    {
      title: '',
      amount: 0,
    },
  ]);
  const [sortedInfo, setSortedInfo] = useState<any>({
    columnKey: {},
    order: [],
  });

  const handleSort = (pagination: any, filters: any, sorter: any) => {
    const sorterOrder: any = {
      ascend: 'asc',
      descend: 'desc',
    };
    if (sorter.columnKey === 'serial_number') {
      setSort({
        meter: {
          serial_number: sorterOrder[sorter.order],
        },
      });
      setSortOrder({
        ...sortOrder,
        meter: {
          serial_number: sorter.order,
        },
      });
    } else if (sorter.columnKey === 'name') {
      console.log('haha', sorter.order);
      setSort({
        first_name: sorterOrder[sorter.order],
      });
      setSortOrder({
        ...sortOrder,
        first_name: sorter.order,
      });
    } else if (sorter.columnKey === 'balance') {
      console.log('yow', sorter.order);
      setSort({
        total_bill: {
          aggregate: {
            sum: {
              total_balance: sorterOrder[sorter.order],
            },
          },
        },
      });
      setSortOrder({
        ...sortOrder,
        total_bill: {
          aggregate: {
            sum: {
              total_balance: sorter.order,
            },
          },
        },
      });
    } else {
      console.log(sorter.columnKey);
      setSort({
        [sorter.columnKey]: sorterOrder[sorter.order],
      });
      setSortOrder({ ...sortOrder, [sorter.columnKey]: sorter.order });
    }
  };

  const [insertFee] = useMutation(mutations.INSERT_SUBSCRIBERS_FEE, {
    onCompleted(res) {
      additional_fee_form.setFieldsValue({
        additional_fees_id: null,
        notes: null,
      });
      message.success('Successful');
      setShowFees(false);
      _getSubscribers();
    },
  });
  const { data: settings_data } = useQuery(queries.GET_SETTINGS, {
    fetchPolicy: 'no-cache',
  });

  const [form] = Form.useForm();
  const [searchForm] = Form.useForm();
  const [additional_fee_form] = Form.useForm();
  const [notesForm] = Form.useForm();
  // const [edit_meter_form] = Form.useForm();
  const [payments_form] = Form.useForm();
  const [deleteSubscriber] = useMutation(mutations.DELETE_SUBSCRIBER, {
    onCompleted(res) {
      message.success('Successful!');
      _getSubscribers();
    },
    onError() {
      message.error('Failed!');
    },
  });
  const { data: meter_data } = useSubscription(subscriptions.GET_METERS, {
    fetchPolicy: 'no-cache',
    variables: {
      where: {
        is_taken: { _eq: false },
      },
    },
  });
  const { data: rate_data } = useQuery(queries.GET_RATE, {
    fetchPolicy: 'no-cache',
  });

  const usersColumns = [
    {
      title: 'Subscriber ID',
      key: 'id',
      render: (item: any) => subs_id(item.id),
      sorter: true,
      sortOrder: sortOrder.id,
    },
    {
      title: 'Meter ID',
      key: 'serial_number',
      dataIndex: 'serial_number',
      sortOrder: sortOrder.meter?.serial_number,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sortOrder: sortOrder.first_name,
    },
    {
      title: 'Address',
      key: 'address',
      render: (item: any) => (
        <div>
          <p className="text-sm p-0 m-0">Municipality: {item.municipality}</p>
          <p className="text-sm p-0 m-0">Barangay: {item.barangay}</p>
          <p className="text-sm p-0 m-0">Address: {item.complete_address}</p>
        </div>
      ),
      sorter: true,
      sortOrder: sortOrder.municipality,
    },
    {
      title: 'Outstanding Balance',
      key: 'balance',
      align: 'center',
      dataIndex: 'balance',
      sorter: true,
      // sorter: (a: any, b: any) =>
      //   `${a.total_bill?.aggregate?.sum?.total_balance} ${a.total_payment?.aggregate?.sum?.amount}`.localeCompare(
      //     `${b.total_bill?.aggregate?.sum?.total_balance} ${b.total_payment?.aggregate?.sum?.amount}`
      //   ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: any) => (
        <Space>
          <Tooltip title="View Profile">
            <Link to={`/customers/${record.id}`}>
              <EyeOutlined />
            </Link>
          </Tooltip>
          {record.balance === null && (
            <Tooltip title="Delete Subscriber">
              <Button
                type="link"
                size="middle"
                icon={<DeleteOutlined />}
                style={{ width: 50 }}
                onClick={() => {
                  confirm({
                    title: 'This will also release the attached meter.',
                    onOk() {
                      deleteSubscriber({
                        variables: {
                          id: record.id,
                        },
                      });
                    },
                  });
                }}
              />
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  const _showHandler = (status?: Boolean) => {
    if (status) {
      console.log('aksdflasjdfj');
      setShowForm(true);
      form.resetFields();
    } else {
      setShowForm(false);
    }
    setShow(true);
    // form.resetFields()
  };
  const _closeHandler = () => {
    setShow(false);
    setShowForm(false);
    setShowMeter(true);
    form.resetFields();
  };

  const [
    getSubscribers,
    { data: subscriber_data, loading: subscriber_loading },
  ] = useLazyQuery(queries.VIEW_CUSTOMER_WITH_BILLS, {
    fetchPolicy: 'no-cache',
  });

  const [updateSubscriber] = useMutation(mutations.INSERT_UPDATE_CUSTOMER, {
    onCompleted(res) {
      message.success('Success');
      _getSubscribers();
    },
    onError({ graphQLErrors }) {
      message.error('Update failed.');
    },
  });

  const [insertPayments] = useMutation<any>(mutations.INSERT_PAYMENTS, {
    onCompleted(res) {
      message.success({ content: 'Payment has been received successfully ' });
      _getSubscribers();
      form.resetFields();
    },
    onError({ graphQLErrors }) {
      message.error('Something is wrong.');
    },
  });

  const _switchHandler = () => {
    setActive(!active);
  };

  const _submitHandler = () => {
    form.submit();
  };

  const { confirm } = Modal;
  const _onFinishPay = (data: any) => {
    confirm({
      title: (
        <span>
          <span>A payment of </span>
          <span className="font-bold">Php {data.amount} </span>
          <span>has been received. Please confirm to proceed.</span>
        </span>
      ),
      icon: <ExclamationCircleOutlined />,
      onOk() {
        insertPayments({
          variables: {
            data: {
              amount: data.amount,
              billing_id: data.billing_id,
              subscribers_id: data.subscriber_id,
              // id: data.id,
              date: moment().format(),
              transacted_by: auth.getUserInfo().id,
            },
          },
        });
      },
    });
  };

  const _onFinish = (data: any) => {
    updateSubscriber({
      variables: {
        data,
      },
    });
  };

  const _onFinishFees = (data: any) => {
    insertFee({
      variables: {
        data,
      },
    });
  };

  const _onFinishSearch = (data: any) => {
    let where: any = {};
    if (data.name) {
      where = {
        _or: [
          {
            name: {
              _ilike: `%${data.name ?? null}%`,
            },
          },
          {
            id: {
              _eq: !isNaN(data.name) ? parseInt(data.name ?? 0) : 0,
            },
          },
        ],
      };
    }

    if (data.municipality) {
      where = {
        ...where,
        municipality: { _eq: data.municipality },
      };
    }

    if (data.barangay) {
      where = {
        ...where,
        barangay: { _eq: data.barangay },
      };
    }

    if (data.meter) {
      if (where?._or) {
        where = {
          ...where,
          _or: [
            ...where?._or,
            { serial_number: { _ilike: `%${data.meter}%` } },
          ],
        };
      } else {
        where = {
          ...where,
          serial_number: { _ilike: `%${data.meter}%` },
        };
      }
    }
    setSubscribers([]);
    getSubscribers({
      variables: {
        where,
        limit: limit,
        offset: offset,
        order_by: sort,
      },
    });
  };

  useEffect(() => {
    _getSubscribers();
  }, [sort]);

  const _getSubscribers = () => {
    getSubscribers({
      variables: {
        limit: limit,
        offset: offset,
        order_by: sort,
      },
    });
  };

  const [getPayments, { data: payments_data }] = useLazyQuery(
    queries.GET_PAYMENTS,
    {
      fetchPolicy: 'no-cache',
    }
  );

  const _getPayments = () => {
    getPayments();
  };

  useEffect(() => {
    if (settings_data) {
      const data = settings_data.settings;
      setSettingsInfo(data);
    }
  }, [settings_data]);

  useEffect(() => {
    if (subscriber_data) {
      setFees();
      setBill();
      setPay();
      setNotes();
      setMeterReading();
      setSubscribers(subscriber_data.subscribers);
    }
  }, [subscriber_data, error]);

  useEffect(() => {
    if (meter_data) {
      const items = meter_data.meters.map(({ id, serial_number }: Meter) => {
        return {
          id,
          serial_number,
        };
      });
      setMeters(items);
    }
  }, [meter_data]);

  useEffect(() => {
    if (rate_data) {
      const items = rate_data.rates.map(({ id, name }: Rate) => {
        return {
          id,
          name,
        };
      });
      setRates(items);
    }
  }, [rate_data]);

  useEffect(() => {
    _getSubscribers();
  }, [getSubscribers]);

  useEffect(() => {
    if (data) {
      const items = data.subscribers.map((subscriber: Customer) => {
        return {
          ...subscriber,
          name: `${subscriber.first_name} ${subscriber.last_name}`,
        };
      });
      setSubscribers(items);
    }
  }, [data]);

  useEffect(() => {
    if (payments_data) {
      const data = payments_data.payments[0];
      setPaymentsInfo(data);
      setVisible(true);
    }
  }, [payments_data]);

  const getKeyValue =
    <T extends object, U extends keyof T>(obj: T) =>
    (key: U) =>
      obj[key];

  useEffect(() => {
    if (settings_data) {
      const {
        region,
        province,
      }: { region: keyof object; province: keyof object } =
        settings_data.settings[0];
      const result: object = getKeyValue(philippines)(region).province_list;
      const municipalities: any = getKeyValue(result)(province);
      const data: { label: string; value: string; barangays: object }[] =
        Object.keys(municipalities.municipality_list).map(key => ({
          label: key,
          value: key,
          barangays: municipalities.municipality_list[key].barangay_list,
        }));
      setMunicipalities(data);
    }
  }, [settings_data]);

  const _formValueChange = () => {
    form.setFieldsValue({ barangay: null });
    _barangaysSetter();
  };

  const subs_id = (id: number): String => {
    var sub_id = `${id}`;
    while (sub_id.length < 7) {
      sub_id = `0${sub_id}`;
    }
    return sub_id;
  };

  const [insertMeter] = useMutation<any>(mutations.INSERT_UPDATE_METER, {
    onCompleted(res) {
      const meter_id = res.insert_meters.returning[0].id;
      form.setFieldsValue({ meter_id });
    },
    onError({ graphQLErrors }) {
      console.log(graphQLErrors);
      message.error('Duplicate serial number.');
    },
  });

  const [showQR, setShowQR] = useState(false);

  const [getCheckMeter, { data: meter_check }] = useLazyQuery(
    queries.GET_METER,
    {
      fetchPolicy: 'no-cache',
    }
  );

  const checkMeterID = (value: any) => {
    getCheckMeter({
      variables: {
        where: {
          serial_number: {
            _eq: value,
          },
        },
      },
    });
  };

  useEffect(() => {
    if (meter_check) {
      const data = meter_check.meters;
      if (data.length > 0) {
        form.setFieldsValue({ meter_id: data[0].id });
      } else {
        insertMeter({
          variables: {
            data: {
              serial_number: meter_id,
            },
          },
        });
      }
    }
  }, [meter_check]);

  const _onFinishScan = (meter_id: string) => {
    if (meter_id) {
      setMeterId(meter_id);
      checkMeterID(meter_id);
      setShowQR(false);
    }
  };

  const { data: addFees_data } = useQuery(queries.GET_ADDFEES, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (addFees_data) {
      const items = addFees_data.additional_fees.map((id: AdditionalFees) => {
        return {
          ...id,
        };
      });
      setAddFees(items);
    }
  }, [addFees_data]);

  const _addNewFee = () => {
    setCustomAddFees([...customAddFees, { title: '', amount: 0 }]);
  };

  const _showProfile = (data: any) => {
    // console.log(data)
    additional_fee_form.resetFields();
    additional_fee_form.setFieldsValue({ subscriber_id: data.id });
    payments_form.resetFields();
    payments_form.setFieldsValue({
      subscriber_id: data.id,
      billing_id: data.billings[0]?.id,
      id: data.payments[0]?.id,
    });
    notesForm.setFieldsValue({ subscriber_id: data.id });
    setUser(data);
    setUserBill(data);
    setUserPayments(data);
    setUserMeterReading(data);
    setShowMeter(false);
    form.setFieldsValue(data);
    _showHandler(false);
    _barangaysSetter();
  };

  const _barangaysSetter = () => {
    if (municipalities.length > 0) {
      if (form.getFieldValue('municipality')) {
        const data: any = municipalities.filter(
          ({ value }) =>
            value.toLowerCase() ===
            form.getFieldValue('municipality').toLowerCase()
        );
        let barangays = data?.[0]?.barangays?.map((barangay: string) => ({
          label: barangay,
          value: barangay,
        }));
        setBarangays(barangays);
      }
    }
  };

  const _searchFormChangeHandler = () => {
    if (searchForm.getFieldValue('municipality')) {
      searchForm.setFieldsValue({ barangay: null });
      const data: any = municipalities.filter(
        ({ value }) =>
          value.toLowerCase() ===
          searchForm.getFieldValue('municipality').toLowerCase()
      );
      console.log(data);

      let barangays = data[0].barangays.map((barangay: string) => ({
        label: barangay,
        value: barangay,
      }));
      setFilterBarangays(barangays);
    }
  };

  const setFees = () => {
    if (user) {
      const result = subscriber_data.subscribers.filter(
        ({ id }: any) => user.id === id
      );
      setAddFeesTable(result?.[0]?.subscribers_additional_fees);
    }
  };

  const setNotes = () => {
    if (user) {
      const result = subscriber_data.subscribers.filter(
        ({ id }: any) => user.id === id
      );
      setNotesTable(result?.[0]?.subscriber_notes);
    }
  };

  useEffect(() => {
    setFees();
    setNotes();
  }, [user]);

  const setBill = () => {
    if (userBill) {
      const result = subscriber_data.subscribers.filter(
        ({ id }: any) => userBill.id === id
      );
      setBillsTable(result?.[0]?.billings);
      setShowReceit(false);
    }
  };

  useEffect(() => {
    setBill();
  }, [userBill]);

  const setPay = () => {
    if (userPayments) {
      const result = subscriber_data.subscribers.filter(
        ({ id }: any) => userPayments.id === id
      );
      setPaymentsTable(result?.[0]?.payments);
    }
  };

  useEffect(() => {
    setPay();
  }, [userPayments]);

  const setMeterReading = () => {
    if (userMeterReading) {
      const result = subscriber_data.subscribers.filter(
        ({ id }: any) => userMeterReading.id === id
      );
      setMeterReadingTable(result?.[0]?.meter?.meter_readings);
    }
  };

  useEffect(() => {
    setMeterReading();
  }, [userMeterReading]);

  const _additionalFeesSubmit = () => {
    additional_fee_form.submit();
  };

  const _paymentsSubmit = () => {
    payments_form.submit();
  };

  const handleCancel = () => {
    setShowReceit(false);
  };

  const [deleteSubscriberAddFee] = useMutation(
    mutations.DELETE_SUBSCRIBERS_ADDITIONAL_FEE,
    {
      onCompleted(res) {
        message.success('Additional fee deleted successfully.');
        _getSubscribers();
      },
      onError({ graphQLErrors }) {
        console.log(graphQLErrors);
        message.error(graphQLErrors[0].message);
      },
    }
  );

  const _onDeleteAdditionalFees = (data: any) => {
    confirm({
      title: `Are you sure you want to delete this fee?`,
      icon: <ExclamationCircleOutlined />,
      onOk() {
        deleteSubscriberAddFee({
          variables: {
            id: data.id,
          },
        });
      },
    });
  };

  // ADDITIONAL FEES COLUMN //
  const subFeecolumns = [
    {
      title: 'Title',
      key: 'title',
      render: (item: any) => {
        return <p>{item.additional_fee?.title}</p>;
      },
    },
    {
      title: 'Type',
      key: 'type',
      render: (item: any) => (
        <Tag color="green">{item?.additional_fee?.mode_of_payment}</Tag>
      ),
    },
    {
      title: 'Amount',
      key: 'amount',
      render: (item: any) => {
        return item.additional_fee.amount;
      },
    },
    {
      title: 'Status',
      key: 'status',
      render: (item: any) => <Tag color="green">{item?.payment_status}</Tag>,
    },
    {
      title: 'No. of Bills',
      render: ({ paid, count }: any) => (
        <Tag>{`${paid.aggregate.count} / ${count.aggregate.count}`}</Tag>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (item: any) => (
        <Space>
          <Tooltip title="Delete Fee">
            <Button
              type="link"
              icon={<DeleteOutlined />}
              size="middle"
              style={{ width: 50 }}
              onClick={() => _onDeleteAdditionalFees(item)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  // PAYMENTS COLUMN //
  const subPayColumn = [
    {
      title: 'Payment ID',
      key: 'id',
      dataIndex: 'id',
    },
    {
      title: 'Bill Total Balance',
      key: 'total_balance',
      render: (item: any) => Math.round(item?.bill?.total_balance * 100) / 100,
    },
    {
      title: 'Paid Amount',
      key: 'amount',
      render: (item: any) => Math.round(item?.amount * 100) / 100,
    },
    {
      title: 'Paid Date',
      key: 'date',
      render: (item: any) => moment(`${item?.date}`).format('LL'),
    },
  ];

  // BILLS COLUMN //
  const subBillColumn = [
    {
      title: 'Bill',
      key: 'id',
      dataIndex: 'id',
    },
    {
      title: 'Billing Date',
      key: 'billing_date',
      render: (item: any) => moment(`${item?.billing_date}`).format('LL'),
    },
    {
      title: 'Current Reading',
      key: 'current_reading',
      dataIndex: 'current_reading',
    },
    {
      title: 'Previous Reading',
      key: 'previous_reading',
      dataIndex: 'previous_reading',
    },
    {
      title: 'Consumption',
      key: 'consumption',
      dataIndex: 'consumption',
      render: (val: any) => Math.round(val * 100) / 100,
    },
    {
      title: 'Bill',
      key: 'total_balance',
      render: (item: any) => Math.round(item?.total_balance * 100) / 100,
    },
    {
      title: 'Total Paid Amount',
      key: 'total_balance',
      render: (item: any) =>
        item?.payments_aggregate?.aggregate?.sum?.amount
          ? `${
              Math.round(
                item?.payments_aggregate?.aggregate?.sum?.amount * 100
              ) / 100
            }`
          : 0,
    },
    {
      title: 'Status',
      render: (item: any) =>
        Math.round(item.total_balance * 100) / 100 <=
        Math.round(item.payments_aggregate.aggregate.sum.amount * 100) / 100
          ? 'Paid'
          : 'Unpaid',
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: any) => (
        <Space>
          <Tooltip title="Show Bill">
            <Button
              type="link"
              icon={<ContainerOutlined />}
              size="middle"
              style={{ width: 50 }}
              onClick={() => {
                getGraphData({
                  variables: {
                    id: record?.subscriber.id,
                  },
                });

                setInfo(record);
                setShowReceit(true);
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  // METER READING TABLE //
  const subMeterColumn = [
    {
      title: 'Reading ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
    },
    {
      title: 'Date',
      dateIndex: 'date_time',
      key: 'date_time',
      render: (_: any, record: { key: React.Key; date_time: any }) => {
        return moment(record.date_time).format('LLL');
      },
    },
  ];

  const [getGraphData, { data: graph_data }] = useLazyQuery(
    queries.GET_GRAPH_BILL_DATA,
    {
      fetchPolicy: 'no-cache',
    }
  );

  useEffect(() => {
    if (graph_data) {
      setGraphDatas({
        labels: graph_data.billings.map(({ billing_date }: any) =>
          moment(billing_date).format('MMM')
        ),
        data: graph_data.billings.map(
          ({ total_balance }: any) => Math.round(total_balance * 100) / 100
        ),
      });
    }
  }, [graph_data]);

  const graphData = {
    labels: graphDatas.labels,
    datasets: [
      {
        label: 'Monthly Bills',
        data: graphDatas.data,
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(54, 162, 235, 0.2)',
        ],
      },
    ],
  };

  // NOTES
  const [insertNotes] = useMutation(mutations.CREATE_NOTE, {
    onCompleted(res) {
      _getSubscribers();
      notesForm.resetFields();
      message.success('Create/Insert Successful');
    },
  });
  const _onFinishNotes = (data: any) => {
    insertNotes({
      variables: {
        data,
      },
    });
  };

  const { data: getCustomerTotal } = useQuery(queries.GET_CUSTOMER_TOTAL, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (getCustomerTotal) {
      const temp = getCustomerTotal.subscribers_aggregate;
      setTotal(temp?.aggregate.count);
    }
  }, [getCustomerTotal]);

  useEffect(() => {
    if (subscriber_data && params?.id) {
      const paramId = params?.id;
      const data = subscriber_data.subscribers.filter(
        ({ id }: any) => id === parseInt(paramId)
      );
      _showProfile(data[0]);
      setShowMeter(false);
    }
  }, [subscriber_data]);

  const handlePaginationChange = (page: any, pageSize: any) => {
    setLimit(pageSize);
    setCurrent(page);
    if (page * pageSize > pageSize) {
      setOffset(page * pageSize - pageSize);
    }
    if (page === 1) {
      setCurrent(page);
      setOffset(0);
    }
  };

  useEffect(() => {
    if (offset || current) {
      _getSubscribers();
    }
  }, [offset, current]);

  const value: object = {
    subscribers,
    record,
    edit,
    usersColumns,
    subFeecolumns,
    addFeesTable,
    meters,
    rates,
    active,
    form,
    show,
    info,
    name,
    billingInfo,
    meterInfo,
    settingsInfo,
    rateInfo,
    paymentsInfo,
    visible,
    displayAmount,
    graphData,
    showQR,
    selectedSubAddFees,
    showForm,
    customAddFees,
    addFees,
    additional_fee_form,
    showFees,
    subPayColumn,
    subBillColumn,
    subMeterColumn,
    billsTable,
    paymentsTable,
    meterReadingTable,
    userMeterReading,
    user,
    showMeter,
    showReceit,
    payments_form,
    municipalities,
    barangays,
    searchForm,
    filterBarangays,
    notesForm,
    notesTable,
    subscriber_loading,
    loading,
    limit,
    offset,
    total,
    current,
    handleSort,
    handlePaginationChange,
    _onFinishNotes,
    _onFinishSearch,
    _searchFormChangeHandler,
    _formValueChange,
    handleCancel,
    setShowFees,
    _onFinishFees,
    _additionalFeesSubmit,
    setAddFees,
    _addNewFee,
    getCustomer,
    setShowQR,
    _onFinishScan,
    _showHandler,
    _closeHandler,
    _switchHandler,
    _submitHandler,
    _onFinish,
    subs_id,
    _getPayments,
    setVisible,
    _onFinishPay,
    _paymentsSubmit,
  };

  return (
    <PageContext.Provider value={value}>
      <CustomersView />
    </PageContext.Provider>
  );
};

export default CustomerController;
